import axios from 'axios'

const instance = axios.create({
	baseURL: 'https://api.michellecpaige.com/',
	crossDomain: true,
	withCredentials: true
})

export default instance